import axios from "axios"

export async function getZknsRecord(address: string){
  return axios
  .get("https://omniapi.zkns.app/domain-resolver/getReverseRecord/" + address)
  .then(response => {
    return response?.data
  })
}